import React from 'react';
import { Link } from 'react-router-dom';
import { Table } from 'react-daisyui';

const ELValidatorsTable = ({ validators }) => {
  return (
    <Table className="w-full">
      <Table.Head>
        <span>Name</span>
        <span>Address</span>
        <span>Total BGT Staked</span>
        <span>Commission</span>
        <span>Active Vaults</span>
      </Table.Head>
      <Table.Body>
        {validators.map((validator) => (
          <Table.Row key={validator.address} className="hover:bg-gray-700 transition-colors duration-200">
            <span>
              <Link to={`/validator/${validator.address}`} className="text-blue-400 hover:text-blue-300 flex items-center">
                {validator.logoUri && (
                  <img 
                    src={validator.logoUri} 
                    alt={`${validator.name} logo`} 
                    className="w-6 h-6 mr-2 rounded-full object-contain bg-white"
                    onError={(e) => { e.target.onerror = null; e.target.src = '/placeholder-logo.png'; }}
                  />
                )}
                {validator.name || 'Unnamed'}
              </Link>
            </span>
            <span className="text-sm">{validator.address}</span>
            <span>{validator.amountStaked.toLocaleString()} BGT</span>
            <span>{(validator.commission * 100).toFixed(2)}%</span>
            <span>{validator.activeVaults?.length || 0}</span>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
};

export default ELValidatorsTable;